export default __webpack_public_path__ + "static/media/back_staff1.7f5a4851.jpg";